// Filename: SearchForm.js
// Description: This component is a form of fields a volunteer can search clients by.
// (First name, Last name, Date of Birth, Phone, ID type, ID number, Email)

import React, { useState } from "react";
import { Search } from 'react-bootstrap-icons';

function SearchForm({ onSearch }) {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    DOB: "",
    email: "",
    phoneNumber: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(formData);
  };

  return (
    <React.Fragment>
      <div className="accordion h-100" id="accordianSearch">
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSearch"
              aria-expanded="true"
              aria-controls="collapseSearch"
            >
              <i className="bi bi-search me-2"></i> 
              <h4 className="mb-0">Client Search</h4> 
            </button>
          </h2>
          <div
            id="collapseSearch"
            className="accordion-collapse collapse show"
            data-bs-parent="#accordionSearch"
          >
            <div className="accordion-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-12 p-2">
                    <div className="form-floating">
                      <input
                        id="txtFirstName"
                        type="text"
                        className="form-control"
                        placeholder="e.g., John"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                      />
                      <label htmlFor="txtFirstName">First name</label>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-12 p-2">
                    <div className="form-floating">
                      <input
                        id="txtLastName"
                        type="text"
                        className="form-control"
                        placeholder="e.g., Doe"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                      />
                      <label htmlFor="txtLastName">Last name</label>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-12 p-2">
                    <div className="form-floating">
                      <input
                        id="txtDOB"
                        type="date"
                        className="form-control"
                        placeholder="01-01-2000"
                        name="DOB"
                        value={formData.DOB}
                        onChange={handleChange}
                      />
                      <label htmlFor="txtDOB">Date of Birth</label>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-12 p-2">
                    <div className="form-floating">
                      <input
                        id="txtPhone"
                        type="tel"
                        className="form-control"
                        placeholder="5551234567"
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                        maxLength={10}
                        title="Phone number must be 10 digits."
                      />
                      <label htmlFor="txtPhone">Phone Number (10 digits)</label>
                    </div>
                  </div>
                  <div className="col-12 p-2">
                    <div className="form-floating">
                      <input
                        id="txtEmail"
                        type="email"
                        placeholder="e.g., jdoe@email.com"
                        className="form-control"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                      <label htmlFor="txtEmail">Email</label>
                    </div>
                  </div>
                </div>

                <div className="d-grid mt-3">
                  <button
                    type="submit" 
                    className="btn btn-primary btn-lg" 
                  >
                    <i className="bi bi-search me-2"></i> 
                    Search
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default SearchForm;